import axios from "axios"
import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"
import { useState } from "react"
import { Card } from "react-bootstrap"
import { CSVLink } from "react-csv"
import * as Feather from 'react-feather'
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import Option from "../components/Option"
import CollapseCard from "../components/custom/CollapseCard"
import FormInput from "../components/custom/FormInput"
import PageContainer from "../components/custom/PageContainer"
import { apiUrl } from "../config"
import { YearOptions } from "../config/functions"
import { CourseType } from "../redux/actions/courseActions"
import { DegreeType } from "../redux/actions/degreeAction"
import { DisciplineType } from "../redux/actions/disciplineAction"
import { DisciplineCourseType } from "../redux/actions/disciplineCourseAction"
import { ExamType } from "../redux/actions/examAction"
import { StoreState } from "../redux/reducers"
import imgPath from './img/collegeLogo.png'

interface PracticalMark {
    registerNumber: number
    totConvertedMark: number
    extMark: number
    name: string
    degreeId: number
    disciplineId: number
    courseCode: string
}

export const inWords = (number: number) => {
    if (number === -1) return 'ABSENT';
    const strArr = (number)?.toString()?.split('');
    const a = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Zero']
    let numberToWord = '';
    for (let i in strArr) {
        if (strArr[i] === '1')
            numberToWord = numberToWord + " " + a[0];
        if (strArr[i] === '2')
            numberToWord = numberToWord + " " + a[1];
        if (strArr[i] === '3')
            numberToWord = numberToWord + " " + a[2];
        if (strArr[i] === '4')
            numberToWord = numberToWord + " " + a[3];
        if (strArr[i] === '5')
            numberToWord = numberToWord + " " + a[4];
        if (strArr[i] === '6')
            numberToWord = numberToWord + " " + a[5];
        if (strArr[i] === '7')
            numberToWord = numberToWord + " " + a[6];
        if (strArr[i] === '8')
            numberToWord = numberToWord + " " + a[7];
        if (strArr[i] === '9')
            numberToWord = numberToWord + " " + a[8];
        if (strArr[i] === '0')
            numberToWord = numberToWord + " " + a[9];
    }
    return numberToWord;

}

const PracticalMarkReport = () => {

    const examList = useSelector<StoreState, ExamType[]>(state => state.exam)
    const courseList = useSelector<StoreState, CourseType[]>(state => state.course)
    const degreeList = useSelector<StoreState, DegreeType[]>(state => state.degree)
    const disciplineList = useSelector<StoreState, DisciplineType[]>(state => state.discipline)
    const disciplineCourseList = useSelector<StoreState, DisciplineCourseType[]>(state => state.disciplineCourse)

    const [exam, setExam] = useState<string>('')
    const [examError, setExamError] = useState<string>('')
    const [degree, setDegree] = useState<string>('')
    const [degreeError, setDegreeError] = useState<string>('')
    const [discipline, setDiscipline] = useState<string>('')
    const [disciplineError, setDisciplineError] = useState<string>('')
    const [disciplineCourse, setDisciplineCourse] = useState<string>('')
    const [disciplineCourseError, setDisciplineCourseError] = useState<string>('')
    const [batch, setBatch] = useState<string>('')
    const [batchError, setBatchError] = useState<string>('')
    const [semester, setSemester] = useState<string>('')
    const [semesterError, setSemesterError] = useState<string>('')
    const yearList = YearOptions();

    const [practicalMark, setPracticalMark] = useState<PracticalMark[]>([])

    const handleSearch = () => {
        if (exam !== '' && degree !== '' && discipline !== '' && batch !== '' && semester !== '' && disciplineCourse !== '') {

            let disciplineCourseId = disciplineCourseList.find(f => f.degreeId?.toString() === degree && f.disciplineId?.toString() === discipline && f.courseId?.toString() === disciplineCourse)?.id

            axios.get<{ data: PracticalMark[] }>(`${apiUrl}/studentMark/practicalMark/?examId=${exam}&degreeId=${degree}&disciplineId=${discipline}&batch=${batch}&semester=${semester}&disciplineCourseId=${disciplineCourseId}&dummyNumber='' `)
                .then((response) => {
                    const result = response.data.data
                    if (result.length > 0) {
                        setPracticalMark(result)
                    } else {
                        setPracticalMark([])
                    }
                })
                .catch((error) => {
                    toast.error(error);
                });
        } else {
            toast.error('Select All Filters', { position: 'top-right', autoClose: 3000 });

            setPracticalMark([])
        }
    }

    const handleDownloadPDF = () => {
        const doc = new jsPDF('p', 'mm', 'a4');
        let examName = examList.find(f => f.id?.toString() === exam)?.title
        let degreeName = degreeList.find(d => d.id?.toString() === degree)?.name
        let disciplineName = disciplineList.find(d => d.id?.toString() === discipline)?.name
        let courseName = courseList.find(d => d.id?.toString() === disciplineCourse)?.name
        let courseCode = courseList.find(d => d.id?.toString() === disciplineCourse)?.shortName

        doc.addImage(imgPath, 'PNG', 20, 10, 170, 40);
        doc.setFontSize(13);
        doc.setFont('Arial', 'normal', 'bold')
        doc.text('Practical Mark Sheet', 80, 50, { align: 'justify' })
        // doc.text('ANNA UNIVERSITY, CHENNAI - 25', 65, 20)
        doc.text(`${examName}`, 75, 60, { align: 'justify' });

        doc.setFontSize(11);
        // doc.text(`College : 8213 - PARISUTHAM INSTITUTE OF TECHNOLOGY AND SCIENCE`, 15, 40)
        doc.text(`Degree & Discipline : ${degreeName} - ${disciplineName}`, 15, 70)
        doc.text(`Course : ${courseCode} - ${courseName}`, 15, 80)


        autoTable(doc, {
            startY: 87,
            headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineWidth: 0.3, lineColor: [0, 0, 0], fontSize: 9 },
            bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineWidth: 0.3, lineColor: [0, 0, 0], halign: 'center', fontSize: 9 },
            head: [
                [
                    { content: "S.No.", styles: { halign: 'center' } },
                    { content: "Register Number", styles: { halign: 'center' } },
                    { content: "Student Name", styles: { halign: 'center' } },
                    { content: "Marks Awarded", styles: { halign: 'center' } },
                    { content: "Mark in Words", styles: { halign: 'center' } }
                ]

            ],
            body: practicalMark?.map((pm, i) => {
                return [(i + 1)?.toString(), pm.registerNumber, { content: pm.name, styles: { halign: 'left' } }, pm.extMark, inWords(pm.extMark)]
            }),
            theme: 'grid',
            tableLineColor: "black",
            margin: { left: 15 }
        })
        // const lastTableContent: RowInput[] = [];
        // lastTableContent.push([
        //     { content: 'INTERNAL EXAMINER 1(S)' },
        //     { content: 'EXTERNALE EXAMINER 1(S)' },
        //     { content: 'SUPERVISOR (S)' },
        // ])
        // autoTable(doc, {
        //     startY: (doc as any).lastAutoTable.finalY + 10,

        //     bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineWidth: 0.3, lineColor: [0, 0, 0], halign: 'center' },

        //     body: lastTableContent,
        //     theme: 'grid',
        //     tableLineColor: "black",
        //     margin: { left: 15 }
        // })
        doc.setFontSize(10)
        // doc.setFont('Arial', 'normal', '');
        doc.text(`Date & Session :`, 15, (doc as any).lastAutoTable.finalY + 7)
        doc.setFontSize(10)
        // doc.setFont('Arial', 'normal', '');
        doc.text(`*Absent must be entered as "-1".`, 15, (doc as any).lastAutoTable.finalY + 15)
        doc.text(`*It is the responsibility of the Examiner ascertain the correctness of the above Marks.`, 15, (doc as any).lastAutoTable.finalY + 20)
        doc.setFontSize(11)
        doc.setFont('Arial', 'normal', 'bold');
        doc.text(`INTERNAL EXAMINER`, 15, (doc as any).lastAutoTable.finalY + 40)
        doc.text(`EXTERNAL EXAMINER`, 150, (doc as any).lastAutoTable.finalY + 40)
        // doc.text(`SUPERVISOR (S)`, 170, (doc as any).lastAutoTable.finalY + 30)

        doc.save('practical_mark_report.pdf');

    }

    const csvData = [
        ['S.No.', 'Register Number', 'Marks Awarded', 'Mark In Words'],
    ]
    practicalMark?.forEach((pm, i) => {
        csvData.push(
            [(i + 1)?.toString(), pm.registerNumber?.toString(), pm.name, pm.extMark?.toString(), inWords(pm.extMark)]
        )
    })

    return <>
        <PageContainer title='Practical Mark Sheet'>
            <Card>
                <div className="row m-2">
                    <div className='col-sm-6 col-md-4 col-lg-3'>
                        <FormInput
                            label='Exam'
                            name='Exam'
                            labelClassName="required"
                            type='select'
                            containerClass="mt-2"
                            value={exam}
                            onChange={(e) => {
                                setExam(e.target.value)
                                setExamError('')
                            }}
                            errorText={examError}
                        >
                            <Option value=''>Select</Option>
                            {examList?.map((e, i) => {
                                return <Option value={e.id} key={i}>{e.title}</Option>
                            })}
                        </FormInput>
                    </div>
                    <div className='col-sm-6 col-md-4 col-lg-3'>
                        <FormInput
                            label='Degree'
                            name='Degree'
                            labelClassName="required"
                            type='select'
                            containerClass="mt-2"
                            value={degree}
                            onChange={(e) => {
                                setDegree(e.target.value)
                                setDegreeError('')
                            }}
                            errorText={degreeError}
                        >
                            <Option value=''>Select</Option>
                            {degreeList?.map((e, i) => {
                                return <Option value={e.id} key={i}>{e.name}</Option>
                            })}
                        </FormInput>
                    </div>
                    <div className='col-sm-6 col-md-4 col-lg-3'>
                        <FormInput
                            label='Discipline'
                            name='Discipline'
                            labelClassName="required"
                            type='select'
                            containerClass="mt-2"
                            value={discipline}
                            onChange={(e) => {
                                setDiscipline(e.target.value)
                                setDisciplineError('')
                            }}
                            errorText={disciplineError}
                        >
                            <Option value=''>Select</Option>
                            {disciplineList?.map((e, i) => {
                                return <Option value={e.id} key={i}>{e.name}</Option>
                            })}
                        </FormInput>
                    </div>
                    <div className='col-sm-6 col-md-4 col-lg-3'>
                        <FormInput
                            label='Course'
                            name='Course'
                            labelClassName="required"
                            type='select'
                            containerClass="mt-2"
                            value={disciplineCourse}
                            onChange={(e) => {
                                setDisciplineCourse(e.target.value)
                                setDisciplineCourseError('')
                            }}
                            errorText={disciplineCourseError}
                        >
                            <Option value=''>Select</Option>
                            {courseList?.map((e, i) => {
                                return <Option value={e.id} key={i}>{e.name}</Option>
                            })}
                        </FormInput>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <FormInput
                            name="Batch"
                            label="Batch"
                            labelClassName="required"
                            value={batch}
                            onChange={(e) => {
                                setBatch(e.target.value)
                                setBatchError('')
                            }}
                            placeholder="Select Batch"
                            containerClass="mt-2"
                            type="select"
                            errorText={batchError}
                        >
                            <option value="">Select Batch</option>
                            {yearList.map((y, i) => {
                                return <Option key={i} value={y}>{y}</Option>
                            })
                            }
                        </FormInput>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <FormInput
                            name="Semester"
                            label="semester"
                            labelClassName="required"
                            value={semester}
                            onChange={(e) => {
                                setSemester(e.target.value)
                                setSemesterError('')
                            }}
                            placeholder="Select Sem"
                            containerClass="mt-2"
                            type="select"
                            errorText={semesterError}
                        >
                            <option value="">Select Semester</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                        </FormInput>

                    </div>
                </div>
                {/* <div className="row align-items-end "> */}
                <div className="text-right m-4">
                    {/* <div className=" col-12 m-2"> */}
                    <button className='btn btn-sm btn-primary' onClick={handleSearch} >Search</button>
                </div>
                {/* </div> */}
            </Card>
            <CollapseCard title="Practical Mark List">
                {/* <div className="container-fluid table-container"> */}
                <div>
                    <table className="table table-success table-striped">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Register Number</th>
                                <th>Student Name</th>
                                <th>Marks Awarded</th>
                                <th>Mark in words</th>
                            </tr>
                        </thead>
                        <tbody>
                            {practicalMark?.map((row, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{row.registerNumber}</td>
                                        <td>{row.name}</td>
                                        <td>{row.extMark}</td>
                                        <td>{inWords(row.extMark)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-6">
                        {practicalMark.length > 0 && <div className="text-end mb-3">
                            <button
                                type="button"
                                onClick={handleDownloadPDF}
                                className="m-1 btn btn-sm btn-primary"
                            >
                                <Feather.Download /> PDF
                            </button>
                            <CSVLink
                                data={csvData}
                                filename="details_of_course.csv"
                                className="m-1 btn btn-sm btn-primary"
                            >
                                <Feather.Download /> CSV
                            </CSVLink>
                        </div>
                        }
                    </div>
                </div>
            </CollapseCard>
        </PageContainer >
    </>
}
export default PracticalMarkReport